import {useState} from "react";
import {condition, request} from "../../../res/rest/restRequest";
import {env} from "../../../res/config/env";
import {api} from "../../../res/rest/api";
import {idempiereDate} from "../../../res/dataServices/idempiereDate";
import useValueChangeListener from "../../../newStructure/services/state/general/useValueChangeListener";
import HttpClient from "../../services/http/HttpClient";
import useSession from "../../services/state/session/useSession";
import runAuthRequest from "../../../redux/util/runAuthRequest";

const getCutOffRequest = () => {
    return request.model("web_shipment_cutoff_v")
        .filter(condition.eq("ad_client_ID", 1000000),
            condition.eq("isActive", "true"))
        .buildRequest(env.API_URL);
}

const getServerCutOff = async (session) => {
    const req = getCutOffRequest();
    const resp = await HttpClient.client.get(req, api.auth(session));
    const records = resp?.data?.records;
    if(records && records.length > 0) {
        return records[0]
    }
    return null;
}

const getLocalCutOff = (cutOffData) => {
    if(!cutOffData) return null;

    const todaysCutOff = idempiereDate.getDate(cutOffData.todayscutoff);
    const serverRemaining = cutOffData.timeremaining;
    const now = new Date();

    const localRemaining = todaysCutOff.getTime() - now.getTime();
    const remainingComparison = Math.abs(serverRemaining - localRemaining);
    const oneMinute = 1000 * 60;

    if(remainingComparison > oneMinute) {
        now.setTime(now.getTime() + serverRemaining);
        return now;
    } else {
        return todaysCutOff;
    }
}

const useDeliveryCutoff = () => {

    const session = useSession();
    const [ cutOff, setCutOff ] = useState(null);

    useValueChangeListener(async () => {
        if(!session?.sessionData) return;
        try {
            const cutOffData = await runAuthRequest(session.sessionData, s => getServerCutOff(s), session.dispatch);
            const calculatedCutOff = getLocalCutOff(cutOffData);
            setCutOff(calculatedCutOff);
        } catch (error) {
            console.log("Delivery cutoff error:", error);
        }
    }, [session?.sessionData], []);

    return cutOff;
}

export default useDeliveryCutoff;
